import { HttpClient, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.development';
import { FarmLocations } from '../../models/types';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  constructor(private http: HttpClient) { }

  GetFarmLocations(): Observable<HttpResponse<FarmLocations[]>> {
    return this.http.get<FarmLocations[]>(environment.farmLocationsURL, { observe: "response" });
  }

  AddFarmLocation(location: FarmLocations): Observable<HttpResponse<any>> {
    return this.http.post(environment.farmLocationsURL, location, { observe: "response" });
  }
}
